import { useEffect, useState } from "react";

import SitePreview from "./SitePreview";
import HotelDefaultsList from "./HotelDefaultsList";
import { fetchSiteData, resolveHotelData } from "../helpers/hotelDefaults";
import { STYLE_SITE_ASIDE } from "../constants";

function SiteAside({ showInherited = false }) {
  const [site, setSite] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const result = await fetchSiteData();
      if (!cancelled) setSite(result);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <aside className={STYLE_SITE_ASIDE}>
      {site && (
        <SitePreview data={resolveHotelData(site.melhous, site.defaults)} />
      )}
      {site && showInherited && (
        <HotelDefaultsList melhous={site.melhous} defaults={site.defaults} />
      )}
    </aside>
  );
}

export default SiteAside;
